import { render, staticRenderFns } from "./QuotationProductTable.vue?vue&type=template&id=f2f2946e&scoped=true"
import script from "./QuotationProductTable.vue?vue&type=script&lang=js"
export * from "./QuotationProductTable.vue?vue&type=script&lang=js"
import style0 from "./QuotationProductTable.vue?vue&type=style&index=0&id=f2f2946e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f2946e",
  null
  
)

export default component.exports